var DialogStateResponse = /** @class */ (function () {
    function DialogStateResponse(state) {
        if (state === void 0) { state = 0; }
        this.messages = null;
        this.dialogPriceData = null;
        this.dialogVoucherData = null;
        this.geopayment = false;
        this.packageTravelDirective = null;
        this.preContractInformation = null;
        this.dialogCouponCode = null;
        this.dialogTransactionData = null;
        this.offerKey = '';
        this.hotelRoomName = '';
        this.hotelRoomOpCode = '';
        this.hotelServiceName = '';
        this.state = state;
    }
    DialogStateResponse.prototype.setState = function (state) {
        this.state = state;
    };
    DialogStateResponse.prototype.getState = function () {
        return this.state;
    };
    DialogStateResponse.prototype.isOk = function () {
        return this.state === 200;
    };
    DialogStateResponse.prototype.setOfferKey = function (offerKey) {
        this.offerKey = offerKey;
    };
    DialogStateResponse.prototype.getOfferKey = function () {
        return this.offerKey;
    };
    DialogStateResponse.prototype.setHotelRoomName = function (hotelRoomName) {
        this.hotelRoomName = hotelRoomName;
    };
    DialogStateResponse.prototype.getHotelRoomName = function () {
        return this.hotelRoomName;
    };
    DialogStateResponse.prototype.setHotelRoomOpCode = function (hotelRoomOpCode) {
        this.hotelRoomOpCode = hotelRoomOpCode;
    };
    DialogStateResponse.prototype.getHotelRoomOpCode = function () {
        return this.hotelRoomOpCode;
    };
    DialogStateResponse.prototype.setHotelServiceName = function (hotelServiceName) {
        this.hotelServiceName = hotelServiceName;
    };
    DialogStateResponse.prototype.getHotelServiceName = function () {
        return this.hotelServiceName;
    };
    DialogStateResponse.prototype.setDialogMessages = function (dialogMessages) {
        this.messages = dialogMessages;
    };
    DialogStateResponse.prototype.getDialogMessages = function () {
        return this.messages;
    };
    DialogStateResponse.prototype.setDialogPriceData = function (dialogPriceData) {
        this.dialogPriceData = dialogPriceData;
    };
    DialogStateResponse.prototype.getDialogPriceData = function () {
        return this.dialogPriceData;
    };
    DialogStateResponse.prototype.setDialogVoucherData = function (dialogVoucherData) {
        this.dialogVoucherData = dialogVoucherData;
    };
    DialogStateResponse.prototype.getDialogVoucherData = function () {
        return this.dialogVoucherData;
    };
    DialogStateResponse.prototype.setGeoPayment = function (geopayment) {
        this.geopayment = geopayment;
    };
    DialogStateResponse.prototype.getGeoPayment = function () {
        return this.geopayment;
    };
    DialogStateResponse.prototype.setPackageTravelDirective = function (packageTravelDirective) {
        this.packageTravelDirective = packageTravelDirective;
    };
    DialogStateResponse.prototype.getPackageTravelDirective = function () {
        return this.packageTravelDirective;
    };
    DialogStateResponse.prototype.setPreContractInformation = function (preContractInformationResponse) {
        this.preContractInformation = preContractInformationResponse;
    };
    DialogStateResponse.prototype.getPreContractInformation = function () {
        return this.preContractInformation;
    };
    DialogStateResponse.prototype.setCouponCode = function (dialogCouponCode) {
        this.dialogCouponCode = dialogCouponCode;
    };
    DialogStateResponse.prototype.getCouponCode = function () {
        return this.dialogCouponCode;
    };
    DialogStateResponse.prototype.setTransactionData = function (dialogTransactionData) {
        this.dialogTransactionData = dialogTransactionData;
    };
    DialogStateResponse.prototype.getTransactionData = function () {
        return this.dialogTransactionData;
    };
    return DialogStateResponse;
}());
export { DialogStateResponse };
export default DialogStateResponse;
